
import { Route, Routes } from 'react-router-dom';

import { ToastContainer } from 'react-toastify';
import { initCustomAlerts } from './helpers/alertError';

import NotFoundPage from './pages/public/NotFoundPage';
import LoginPage from './pages/auth/LoginPage';
import Redirect from './pages/auth/RedirectPage';
import ProtectedRoute from './wrappers/auth/ProtectedRoute';
import AdminNav from './navigation/MainNav';


function App() {

  // Initialiser le remplacement des alerts
  initCustomAlerts();

  return (

    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/redirect" element={<Redirect />} />

        <Route path="/admin/*" element={<ProtectedRoute allowedRoles={["admin"]}>
          <AdminNav />
        </ProtectedRoute>} />
   

        <Route path="*" element={<NotFoundPage />} />


      </Routes>

    </>
  );
}

export default App;
